<template>
    <div class="hello-page-wrapper video-player-wrapper fixgraybgpl">
        <div :class="{'animated zoomOutLeft': videoCompleted}" v-show="!videoSqueeze" class="video-player-background">
            <div class="container-fluid">
                <div class="row">
                    <div class="video-player" @mouseleave="addRightHoverWidthClass ? resetClass(true) : resetClass(false)">
                        <div class="left-video-icons" v-show="!hideLeftVideoIcons"></div>
                        <div v-if="currentVideo" class="reset-video-width" :class="{'enjoy-hover': addEnjoyHoverClass}">
                        <jwplayer id="mainVideoPlayer" :data="currentVideo" :on-complete="onVideoComplete">Loading the player...</jwplayer>
                        </div>
                    </div>
                    <div class="playlistholderdiv" v-if="playlistVideos">
                        <h4 v-if="playlistVideos"> {{playlistVideos.title}}</h4>
                        <p>({{videoIndex}} of {{playlistVideos.length}})</p>

                        <div v-if="playlistVideos"  v-for="item in playlistVideos">
                            <div class="playlistentrydiv" :class="{'playing': item.videoCode === $route.params.videoCode, 'gray': !user && getVideoIndex(playlistVideos, item.videoCode) > 3}">
                                <img :src="item.thumbnailURL" style="cursor: pointer" @click="playVideo(item.userPlaylistId, item.videoCode)" :alt="item.videoTitle" :title="item.videoTitle"/>
                                <p style="cursor:pointer;"  @click="playVideo(item.userPlaylistId, item.videoCode)">{{item.videoTitle}}</p>
                            </div>
                        </div>
                        <button type="button" @click="copyPlaylist($route.params.playlistId, user.userId)" class="btn formButton btn-block" v-if="user && getUserSharedPlaylists[0] && getUserSharedPlaylists[0].userPlaylistType === 1">
                            Add to Playlists
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--<div v-if="!videoCompleted" class="container">-->
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="player-content">
                        <h4 v-if="currentVideo">{{currentVideo.title}}&nbsp;(Playing&nbsp;{{videoIndex}} of {{playlistVideos.length}})</h4>
                        <p v-if="currentVideo">
                            {{currentVideo.Description}}
                        </p>
                        <div class="profile-content" v-if="getExpert">
                            <a :href="'/expert/' + getExpert[0].expertId + '/' + getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" target="_blank" rel="opener">
                            <img v-bind:src="getExpert[0].small_image" :alt="getExpert[0].name" :title="getExpert[0].name">
                            <h4>{{getExpert && getExpert[0].name}}</h4>
                            <span>{{getExpert && getExpert[0].experties}}</span>
                            </a>
                        </div>
                        <p class="video-text">
                            {{getExpert && getExpert[0].areasofexpertise}}
                        </p>
                        <!--<div class="row">-->
                            <!--<div class="col-xs-4 col-sm-4 col-md-4 col-lg-3" v-if="getCurrentVideoTranscript">-->
                                <!--<button class="btn btn-danger recently-watched-btn btn-transparent btn-lg"-->
                                        <!--@click="toggleViewTranscript">-->
                                    <!--<span v-show="!viewTranscript">View Transcript</span>-->
                                    <!--<span v-show="viewTranscript">Hide Transcript</span>-->
                                <!--</button>-->
                            <!--</div>-->
                            <!--<div class="col-xs-12 col-sm-8 col-md-8 col-lg-9">-->
                                <!--<div class="side-content" v-if="getCurrentVideoTranscript">-->
                                    <!--<div v-show="viewTranscript" class="boxes"-->
                                         <!--:class="{'animated fadeIn': viewTranscript, 'animated fadeOut': !viewTranscript}"-->
                                         <!--&gt;-->
                                        <!--<pre><p v-html="getCurrentVideoTranscript.vtt_file">-->
                                        <!--</p></pre>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="profile-content" v-if="getExpert">-->
                            <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                            <!--<h4>{{getExpert[0].name}}</h4>-->
                            <!--<span>{{getExpert[0].experties}}</span>-->
                        <!--</div>-->
                        <!--<p class="video-text">-->
                            <!--{{getExpert[0].biography}}-->
                        <!--</p>-->
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="recently-watched" style="margin-bottom: 10px;" v-if="showPlaylist">-->
            <!--<div class="container">-->
                <!--<div class="row" v-if="playlistVideos">-->
                    <!--<div class="col-md-12">-->
                        <!--<h2>PLAYLIST</h2>-->
                    <!--</div>-->
                    <!--<div class="col-md-12">-->
                        <!--<div class="content">-->
                            <!--<div class="slider responsive-slick-slider">-->
                                <!--<div v-for="item in playlistVideos.userPlaylistVideos">-->
                                    <!--<div class="slide-player playlistentrydiv" :class="{'playingMobile': item.videoCode === $route.params.videoCode}">-->
                                        <!--<img :src="item.thumbnailURL" style="cursor: pointer" @click="playVideo(playlistVideos.playlistId, item.videoCode) "/>-->
                                        <!--<p class="text-wrap-title">-->
                                            <!--<i class="fa fa-play-circle-o"></i>{{item.videoTitle}}-->
                                        <!--</p>-->
                                        <!--&lt;!&ndash;<hr>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<p class="right-heart-icon">&ndash;&gt;-->
                                        <!--&lt;!&ndash;<i class="fa fa-2x fa-heart-o"&ndash;&gt;-->
                                        <!--&lt;!&ndash;v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</p>&ndash;&gt;-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="recently-watched">
            <div class="container">
                <div class="row" v-if="getAuthRecommendedVideos && user">
                    <div class="col-md-12">
                        <h2>RELATED VIDEOS</h2>
                    </div>
                    <div class="col-md-12">
                        <div class="content">
                            <div class="slider responsive-slick-slider">
                                <div v-for = "reccentVideo in recommendationList">
                                    <div class="slide-player" >
                                        <img class="jw-img" :src="reccentVideo.image" @click="setVideoPlayerObject(reccentVideo.mediaid, reccentVideo.title)" :title="reccentVideo.title" :alt="reccentVideo.title" />
                                        <p class="text-wrap-title">
                                            <i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}
                                        </p>
                                        <!--<hr>-->
                                        <!--<p class="right-heart-icon">-->
                                            <!--<i class="fa fa-2x fa-heart-o"-->
                                               <!--v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>-->
                                        <!--</p>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg">View All Your Videos</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import { dateHelpers } from '../helpers/dateHelpers.js'

    export default {
        name: 'player',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList
        },
        data: function () {
            return {
                activeTab: 0,
                currentVideo: '',
                currentStatus: '',
                currentVideoCode: '',
                recommendationList: '',
                videoCompleted: false,
                videoSqueeze: false,
                hideLeftVideoIcons: false,
                addRightHoverWidthClass: false,
                addIconHoverWidthClass: false,
                showRateHoverBox: false,
                showShareHoverBox: false,
                showEnjoyHoverBox: false,
                addRightHoverEnjoyClass: false,
                addEnjoyHoverClass: false,
                captionTrack: '',
                viewTranscript: false,
                ratingOne: false,
                ratingTwo: false,
                ratingThree: false,
                ratingFour: false,
                hideAll: false,
                videoMessage: '',
                videoMessageIndex: Math.floor(Math.random() * 7),
                videoGif: '',
                videoGifIndex: Math.floor(Math.random() * 4),
                videoURL: window.location.href,
                playlistVideos: null,
                videoIndex: 0,
                showPlaylist: false,
                eventRef: null,
                titleURL: ''
            }
        },
        methods: {
            copyPlaylist (playlistId, userId) {
                let self = this
                let sharedPayload = {
                    playlistId: playlistId,
                    sharedToUserId: userId
                }
                this.$store.dispatch('COPYPLAYLIST', {copyPlaylistObject: sharedPayload}).then(() => {
                    if (self.getCopiedPlaylistObject) {
                        self.$swal({
                            title: 'Playlist Created',
                            text: 'Redirecting..',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.$router.push(`/playlist/${self.getCopiedPlaylistObject[0].playlistId}/play/${self.$route.params.videoCode}`)
                    } else {
                        self.$swal({
                            title: 'Playlist could not be created',
                            text: '',
                            type: 'error',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                })
            },
            sortPlaylist (a, b) {
                if (parseInt(a.eventVideoId) < parseInt(b.eventVideoId)) {
                    return -1
                }
                if (parseInt(a.eventVideoId) > parseInt(b.eventVideoId)) {
                    return 1
                }
                return 0
            },
            getVideoIndex (videoArray, videoCode) {
                var index
                for (var i = 0; i < videoArray.length; ++i) {
                    if (videoArray[i].videoCode === videoCode) {
                        index = i
                        break
                    }
                }
                return index + 1
            },
            toggleViewTranscript () {
                this.viewTranscript = !this.viewTranscript
            },
            redirectToRelatedVideos () {
                this.$router.push(`/relatedvideos`)
            },
            getNextVideo (index) {
                if (index >= 0 && index < this.playlistVideos.length - 1) {
                    return this.playlistVideos[index + 1]
                } else {
                    return null
                }
            },
            playVideo (playlistId, videoCode) {
                if (this.user) {
                    this.$router.push(`/playlistshare/${playlistId}/play/${videoCode}`)
                    window.location.reload()
                } else {
                    if (this.getVideoIndex(this.playlistVideos, videoCode) <= 3) {
                        this.$router.push(`/playlistshare/${playlistId}/play/${videoCode}`)
                        window.location.reload()
                    }
                }
            },
            onVideoComplete () {
                let nextVideoReference = this.getNextVideo(this.videoIndex - 1)
                if (nextVideoReference && this.user) {
                    this.$router.push(`/playlistshare/${this.$route.params.playlistId}/play/${nextVideoReference.videoCode}`)
                    window.location.reload()
                } else {
                    if (nextVideoReference && this.getVideoIndex(this.playlistVideos, nextVideoReference.videoCode) <= 3) {
                        this.$router.push(`/playlistshare/${this.$route.params.playlistId}/play/${nextVideoReference.videoCode}`)
                        window.location.reload()
                    }
                }
              //  this.$router.push(`/playlist/${this.$route.params.playlistId}`)
             // Method to redirect to next video
            },

            setUserLike () {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt((watchedDuration / this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set User Like/Dislike
                if (this.currentStatus.liked === '1') {
                    this.currentStatus.liked = '0'
                } else {
                    this.currentStatus.liked = '1'
                }
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setOpinion (desc) {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set Opinion
                let opinion = '0'
                if (desc === 'travel') {
                    opinion = '1'
                } else if (desc === 'dating') {
                    opinion = '2'
                } else if (desc === 'news') {
                    opinion = '3'
                } else if (desc === 'recipes') {
                    opinion = '4'
                } else {
                    opinion = '0'
                }
                // Uncheck selected optionss
                if (this.currentStatus.opinion === opinion) {
                    this.currentStatus.opinion = '0'
                } else {
                    this.currentStatus.opinion = opinion
                }
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setRating (rating) {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Uncheck selected rating
                if (this.currentStatus.rating === rating) {
                    this.currentStatus.rating = '0'
                } else {
                    this.currentStatus.rating = rating
                }
               // this.currentStatus.rating = rating
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            logVideoEntry () {
                let logWatchedEntry = {
                    videoCode: this.$route.params.videoCode,
                    userId: this.user.userId,
                    playlistId: null,
                    playlistCode: null,
                    watched: 'N',
                    rating: null,
                    liked: '0',
                    durationWatched: 0,
                    thumbnailURL: null,
                    opinion: null
                }
                this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                })
            },
            setVideoPlayerObject (videoCode, videoTitle) {
                this.$router.push(`/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
                location.reload()
            },
            applyRatingClass (rating) {
                if (rating === this.currentStatus.rating) {
                    return true
                } else {
                    return false
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.each(function () {
                    // var length = $(this).children().length <= 5
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            toggleVideoCompleted () {
                var self = this
                self.videoCompleted = true
                setTimeout(function () {
                    self.videoSqueeze = true
                }, 200)
            },
            replayVideo () {
//                let self = this
                let videoCode = this.$route.params.videoCode
                this.videoCompleted = false
                this.videoSqueeze = false
                this.$router.push(`/watch/${videoCode}`)
                this.setVideoPlayerObject(videoCode)
//                this.created.apply(this)
            },
            changeHeight () {
//                $('.left-video-icons').hide()
//                $('.rate-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showRateHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showShareHoverBox = false
                this.showEnjoyHoverBox = false
            },
            showSharing () {
//                $('.left-video-icons').hide()
//                $('.share-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showShareHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showRateHoverBox = false
                this.showEnjoyHoverBox = false
            },
            redirectToHome () {
                this.$router.push('/')
            },
            showEnjoy () {
//                $('.enjoy-hover-box').show()
//                $('.left-video-icons').hide()
//                $('.right-video-icons').addClass('right-hover-enjoy')
//                $('.icons-hover').addClass('icon-hover-width')
//                $('div.reset-video-width').addClass('enjoy-hover')
                this.showEnjoyHoverBox = true
                this.hideLeftVideoIcons = true
                this.addRightHoverEnjoyClass = true
                this.addIconHoverWidthClass = true
                this.addEnjoyHoverClass = true
                this.showRateHoverBox = false
                this.showShareHoverBox = false
            },
            resetClass (bool) {
                if (bool) {
                    this.hideLeftVideoIcons = false
                    this.addRightHoverWidthClass = false
                    this.addRightHoverEnjoyClass = false
                    this.addIconHoverWidthClass = false
                    this.showRateHoverBox = false
                    this.showShareHoverBox = false
                    this.showEnjoyHoverBox = false
                    this.addEnjoyHoverClass = false
                } else {
                }
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            }
        },
        watch: {
//            '$(window).width()' (to, from) {
//                console.log('width of screen', $(window).width())
//                if ($(window).width() > 739) {
//                    this.showPlaylist = false
//                } else {
//                    this.showPlaylist = true
//                }
//            }
        },
        mounted: function () {
            let self = this
            if (self.user && self.user.trialEndDate) {
                let endingDate = new Date(self.user.trialEndDate.substr(0, 10))
                let currentDate = new Date()
                let remainingDays = dateHelpers.getDatesDifference(endingDate, currentDate, 'days')
                if (remainingDays < 0) {
                    self.$router.push('/becomemember')
                }
            }
            // Log user activity
            if (self.$route.params.playlistId && self.$route.params.videoCode) {
                let userId = self.user ? self.user.userId : 0
                let payload = []
                payload.push(self.$route.params.playlistId)
                payload.push(userId)
                self.$store.dispatch('GETSHAREDPLAYLISTS', payload).then(() => {
                    if (self.getUserSharedPlaylists && self.getUserSharedPlaylists[0].copiedPlaylistId === 0) {
                        let findPlaylist = self.getUserSharedPlaylists.filter(x => {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString()
                        })
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                let findVideo = findPlaylist[0].userPlaylistVideos.filter(x => {
                                    return x.videoCode.toString() === self.$route.params.videoCode.toString()
                                })
                                if (findVideo && findVideo.length > 0) {
                                    self.playlistVideos = findPlaylist[0].userPlaylistVideos
                                    self.videoIndex = this.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode)
//                                    self.videoIndex = findPlaylist[0].userPlaylistVideos.findIndex(x => x.videoCode === self.$route.params.videoCode)
                                    // Retreive Video Object
                                    self.$store.dispatch('GETCURRENTVIDEO', self.user ? self.$route.params.videoCode : findVideo[0].promoVideoCode).then(() => {
                                        let video = this.getCurrentVideo
                                        self.currentVideo = {
                                            video: video[0].sources[video[0].sources.length - 1].file,
                                            title: video[0].title,
                                            img: video[0].image,
                                            playerID: new Date(),
                                            tracks: video[0].tracks,
                                            Description: video[0].description,
                                            mediaId: video[0].mediaid
                                        }
                                        self.$store.dispatch('GETEXPERT', video[0].expertid).then(() => {
                                        })
                                    })
                                    // Get Video Transcript
                                    self.$store.dispatch('GETVIDEOTRANSCRIPT', self.$route.params.videoCode).then(() => {
                                    })
                                    // Get Recommended Videos
                                    if (self.user) {
                                        self.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', self.user.userId).then(() => {
                                            let filteredList = this.getAuthRecommendedVideos.filter(code => {
                                                return code.mediaid !== this.currentVideoCode
                                            })
                                            this.recommendationList = filteredList
                                            setTimeout(() => {
                                                this.setCarousal()
                                            }, 2000)
                                            // this.recommendedVideos = this.getAuthRecommendedVideos
                                        })
                                    }
                                } else {
                                    console.info('1')
                                    self.$router.push('/')
                                }
                            } else {
                                console.info('2')
                                self.$router.push('/')
                            }
                        } else {
                            console.info('3')
                            self.$router.push('/')
                        }
                    } else if (self.getUserSharedPlaylists && self.getUserSharedPlaylists[0].copiedPlaylistId > 0) { // User has already made this to his playlistconsole.info('4')
                        let newPlaylistId = self.getUserSharedPlaylists[0].copiedPlaylistId
                        self.$router.push(`/playlist/${newPlaylistId}/play/${self.$route.params.videoCode}`)
                    } else {
                        console.info('5')
                        self.$router.push('/')
                    }
                })
            } else {
                console.info('6')
                self.$router.push('/')
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert',
                'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getArchivePlaylist', 'getUserSharedPlaylists', 'getCopiedPlaylistObject']
            )
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .video-player-wrapper .watch-again .current-video-img img {
        object-fit: cover;
    }
    .video-player .right-video-icons .enjoy-hover-box {
        width: 20%;
        height: 100%;
        background: #f0617d;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15% 0px 0;
        text-align: left;
    }
    .video-player .right-video-icons .enjoy-hover-box button.btn {
        margin: 0 0 10px;
        border-color: white;
        border-radius: 3px;
        padding: 12px 0 13px;
        display: block;
        width: 80%;
        margin: 0px auto 10px;
        color: #fff;
    }
    .video-player-wrapper .tooltipBox {
        width: 100%;
        text-align: center;
        padding-bottom: 10px;
        height: 35px;
        margin-top: 24px;
    }
    @media (min-width:768px) {
        .video-player .right-video-icons .enjoy-hover-box {
            padding: 117px 0px 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating {
            overflow: hidden;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating p {
            color: white;
            display: block;
            font-size: 16px;
            letter-spacing: 0.5px;
            margin-top: 23px;
            margin-bottom: 20px;
            padding: 0 10%;
            text-align: center;
        }
    }
    .video-player .right-video-icons .rate-hover-box span {
        margin-bottom: 20px;
    }
    .video-player .right-video-icons .rate-hover-box button:hover {
        background: #ac2925;
    }
    .video-player .btn-danger:focus {
        background: inherit;
        border-color: inherit;
        outline: none;
    }
    .video-player .right-video-icons div button.btn-danger:hover{
        background:rgba(0,0,0,0.1);
    }
    .video-player .right-video-icons div button.btn-danger.active:hover{
        background:#ac2925;
    }
    .video-player .right-video-icons div button.btn-danger.active:focus{
    color: #fff;
    background-color: #ac2925;
    border-color: #fff;
    }
    .profile-content img {
        object-fit: cover;
        object-position: center center;
    }
    .playlistholderdiv {
        width: 15%;
        color: #fff;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15px;
        bottom: 0;
        overflow-y: auto;
    }

    .playlistholderdiv img {
        max-width: 100%;
        margin: 0 0 10px;
    }

    .fixgraybgpl .video-player-background {
        position: relative;
    }

    .playlistholderdiv h4 {
        font-size: 16px;
    }

    .playlistholderdiv p {
        font-size: 14px !important;
    }
    .playlistentrydiv {
        position: relative;
    }

    .playlistentrydiv.playing:after {
        position: absolute;
        right: 0;
        text-align: center;
        font-weight: 900;
        text-shadow: 0 1px 3px rgba(0,0,0,0.75);
        content: "";
        height: 0;
        width: 0;
        border: 10px solid transparent;
        top: 2px;
        border-left-color: #f0617d;
        -webkit-transform: translateY(-0%);
        transform: translateY(-0%);
        left: 2px;
    }
    .playlistentrydiv.playingMobile:after {
        position: absolute;
        right: 0;
        text-align: center;
        font-weight: 900;
        text-shadow: 0 1px 3px rgba(0,0,0,0.75);
        content: "";
        height: 0;
        width: 0;
        border: 10px solid transparent;
        top: 2px;
        border-left-color: #f0617d;
        -webkit-transform: translateY(-0%);
        transform: translateY(-0%);
        left: 2px;
    }
    .playlistholderdiv button.btn.formButton.btn-block {
        border-radius: 5px;
    }
    @media(max-width:1024px) {
        .playlistholderdiv {
            width: 100%;
            position: static;
        }
        .playlistholderdiv img {
            width: 100px;
            float: left;
            margin: 0px 15px 15px 0;
        }

        .playlistentrydiv {
            overflow: hidden;
            text-align: left;
            border-bottom: 1px solid #666;
            margin: 0 0 15px;
        }
        div:last-of-type > .playlistentrydiv {
            margin: 0;
            border-bottom: 0 none transparent;
        }

        div:last-of-type > .playlistentrydiv img {
            margin-bottom: 0;
        }

    }
    .gray:before {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: block;
        content: "";
        background: rgba(0, 0, 0, 0.58);
    }

    .gray {
        position: relative;
    }
</style>

<style>

    body{
        -ms-overflow-style:scrollbar;
    }
    .fixgraybgpl .video-player .left-video-icons{background:transparent;}
    @media(max-width:992px) {
        .side-content pre {
            overflow: scroll;
            white-space: pre-wrap;
        }
        .fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {
            height: auto !important;
        }
    }
    /*@media (max-width: 991px) and (min-width: 320px){
        .fixgraybgpl .video-player .reset-video-width {
            max-width:85%;
        }
    }*/
</style>



// WEBPACK FOOTER //
// SharePlaylistPlayer.vue?33f28846